module.exports = __webpack_public_path__ + "static/media/buffet22.ea4f83b2.jpg";